import { render, staticRenderFns } from "./CatchBloodPressureMonitor.vue?vue&type=template&id=54547875&scoped=true"
import script from "./CatchBloodPressureMonitor.vue?vue&type=script&lang=js"
export * from "./CatchBloodPressureMonitor.vue?vue&type=script&lang=js"
import style0 from "./CatchBloodPressureMonitor.vue?vue&type=style&index=0&id=54547875&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54547875",
  null
  
)

export default component.exports